export default "__VITE_ASSET__S1HuL658__"